/**
 * @ngdoc service
 * @name proximus.core.platform.service:WebFlatFormService
 * @description
 * # WebFlatFormService
 *  provides x caller chain headers
 */
export default class WebPlatformService {
    constructor(configurationService) {
        this.configurationService = configurationService;
        this._configurationService = this.configurationService;
    }
    getXCallerChainHeader() {
        const applicationPath = location.pathname;
        const url = location.href || '';
        let routerInfo = '';
        if (url.indexOf('#') > -1) {
            routerInfo = url.substring(url.indexOf('#'), url.indexOf('?') > -1 ? url.indexOf('?') : undefined);
        }
        return this._configurationService.getApplicationName() + ':' + applicationPath + routerInfo;
    }
}
